import $ from 'jquery';
import ClipboardJS from 'clipboard';


$.initialize('[data-role="clipboard-button"]', function () {
    $(this).clipboardButton();
});

$.fn.clipboardButton = function () {
    this.each(function () {
        var $btn = $(this);
        var $targets = $($btn.data('clipboard-target'));

        var getTexts = function () {
            var text = '';
            $targets.each(function (index, item) {
                text = text + $(item).text();
            });
            return text;
        };

        var getConfirmationText = function (jqelem) {
            var text = '';
            if (jqelem.length > 0 && jqelem.attr('data-content') != '') {
                text = jqelem.attr('data-content');
            } else {
                $targets.each(function (index, item) {
                    text = text + $(item).text();
                });
            }
            return text;
        };

        new ClipboardJS(this, {text: getTexts});

        $btn.hover(
            function () {
                $targets.each(function (index, item) {
                    $(item).addClass('clipboard-data-highlight');
                });
            },
            function () {
                $targets.each(function (index, item) {
                    $(item).removeClass('clipboard-data-highlight');
                });
            }
        );

        $btn.attr('data-variation', 'inverted').attr('data-content', getConfirmationText($btn)).popup({
            on: 'click',
            observeChanges: false,
            onShow: function () {
                setTimeout(function () {
                    $btn.popup('hide');
                }, 2000);
            }
        });
    });
};

